import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextItemsClass = () => {
  const { t } = useTranslation(i18nNS.common);

  const items = [
    { value: 'economy', label: t('common:Items.Economy') },
    { value: 'business', label: t('common:Items.Business') },
    { value: 'first', label: t('common:Items.First') },
  ];
  return [items];
};

export default useTextItemsClass;
